
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 46 46","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"22.5","cy":"22.5","r":"22.5","fill":"#4fa2b7"}}),_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M30.5 14.5L29 13l-1.5 1.5L26 13l-1.5 1.5L23 13l-1.5 1.5L20 13l-1.5 1.5L17 13v14h-3v3c0 1.7 1.3 3 3 3h12c1.7 0 3-1.3 3-3V13l-1.5 1.5zM30 30c0 .5-.5 1-1 1s-1-.5-1-1v-3h-9V16h11v14z"}}),_c('path',{attrs:{"d":"M20 18h6v2h-6zM27 18h2v2h-2zM20 21h6v2h-6zM27 21h2v2h-2z"}})]),_c('path',{attrs:{"d":"M11 11h24v24H11V11z","fill":"none"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/assetReservationFill.svg